// Language-aware helpers over challenges + activities data.
import { CHALLENGES, DIFFICULTY_STYLES } from "./challenges";
import { ACTIVITIES, CATEGORIES } from "./activities";
import { CHALLENGE_ES, ACTIVITY_ES, AGE_ES, FILTER_LABELS_ES, CATEGORY_ES } from "../i18n/data.es";

export function localizedChallenges(lang) {
  if (lang !== "es") return CHALLENGES;
  return CHALLENGES.map((c) => {
    const es = CHALLENGE_ES[c.id] || {};
    return {
      ...c,
      title: es.title || c.title,
      description: es.description || c.description,
      steps: es.steps || c.steps,
      age_display: AGE_ES[c.age] || c.age,
    };
  });
}

export function localizedActivities(lang) {
  if (lang !== "es") return ACTIVITIES;
  return ACTIVITIES.map((a) => {
    const es = ACTIVITY_ES[a.id] || {};
    return {
      ...a,
      name: es.name || a.name,
      description: es.description || a.description,
      bonus_title: es.bonus_title || a.bonus_title,
      bonus_body: es.bonus_body || a.bonus_body,
      age_display: AGE_ES[a.age] || a.age,
      env_display: FILTER_LABELS_ES[a.env] || a.env,
      time_display: FILTER_LABELS_ES[a.time] || a.time,
      cost_display: FILTER_LABELS_ES[a.cost] || a.cost,
      day_display: FILTER_LABELS_ES[a.day] || a.day,
      group_display: FILTER_LABELS_ES[a.group] || a.group,
    };
  });
}

export function localizedAge(age, lang) {
  if (lang !== "es") return age;
  return AGE_ES[age] || age;
}

export function localizedFilter(v, lang) {
  if (lang !== "es") return v;
  return FILTER_LABELS_ES[v] || v;
}

export function localizedCategory(cat, lang) {
  if (lang !== "es" || !cat) return cat;
  const es = CATEGORY_ES[cat.id];
  if (!es) return cat;
  return { ...cat, label: es.label || cat.label, short: es.short || cat.short };
}

export function localizedCategories(lang) {
  if (lang !== "es") return CATEGORIES;
  return CATEGORIES.map((c) => localizedCategory(c, lang));
}

export function localizedDifficulty(d, lang) {
  if (lang !== "es") return d;
  const map = { Easy: "Fácil", Medium: "Medio", "Go Big": "A lo grande" };
  return map[d] || d;
}

export { DIFFICULTY_STYLES };
